module.exports = __webpack_public_path__ + "Roboto-Regular.df7b648ce5356ea1ebce.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/font/roboto/Roboto-Regular.ttf
// module id = ../../../../angular-bootstrap-md/font/roboto/Roboto-Regular.ttf
// module chunks = 3